// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*#region Blue*/
/*#endregion */
/*#region Blue-Grey*/
/*#endregion */
/*#region Red*/
/*#endregion */
/*#region Green*/
/*#endregion */
/*#region Yellow*/
/*#endregion*/
/*#region Misc*/
/*#endregion*/
:host {
  display: inline-block;
  vertical-align: top;
}

:host.is-date {
  width: 148px;
  margin-right: 10px;
}

:host.is-time {
  width: 112px;
}

.datetime-control {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
  width: 100%;
  height: 45px;
  padding: 14px 8px 0 12px;
  box-sizing: border-box;
  border: none;
  border-radius: 5px;
  background: #3b5873;
  color: #9dbcda;
  font-family: Helvetica, Arial, sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.2;
  text-align: left;
  cursor: pointer;
}
.datetime-control:disabled {
  cursor: default;
  opacity: 0.7;
}
.datetime-control:focus-visible {
  outline: 2px solid #52aaff;
  outline-offset: 1px;
}

.datetime-value {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
}

.datetime-icon {
  flex: 0 0 auto;
  width: 16px;
  height: 16px;
  margin-bottom: 6px;
}

.datetime-panel {
  --mat-datepicker-calendar-text-font: Helvetica, Arial, sans-serif;
  --mat-datepicker-calendar-text-size: 14px;
  --mat-datepicker-calendar-text-color: #1f2937;
  --mat-datepicker-calendar-period-button-text-size: 16px;
  --mat-datepicker-calendar-period-button-text-weight: 500;
  --mat-datepicker-calendar-period-button-text-color: #1f2937;
  --mat-datepicker-calendar-date-selected-state-background-color: #52aaff;
  --mat-datepicker-calendar-date-selected-state-text-color: #fff;
  --mat-datepicker-calendar-date-today-outline-color: #52aaff;
  --mat-sys-body-medium-font: Helvetica, Arial, sans-serif;
  --mat-sys-on-surface: #1f2937;
  --mat-sys-on-surface-variant: #1f2937;
  width: 296px;
  background: #fff;
  border: 1px solid #e4e7eb;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.16);
  overflow: hidden;
  color: #1f2937;
  font-family: Helvetica, Arial, sans-serif;
}
.datetime-panel.is-time {
  width: 168px;
}

.datetime-panel .mat-calendar {
  width: 296px;
}

.datetime-clock {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 8px;
}

.datetime-unit {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.datetime-unit span {
  font-size: 18px;
  line-height: 1.2;
  min-width: 2ch;
  text-align: center;
}
.datetime-unit button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 24px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #52aaff;
  cursor: pointer;
}
.datetime-unit button svg {
  width: 12px;
  height: 8px;
}

.datetime-colon {
  font-size: 18px;
  line-height: 1;
}

::ng-deep .datetime-panel .mat-calendar-period-button .mdc-button__label,
::ng-deep .datetime-panel .mat-calendar-table-header th {
  text-transform: capitalize;
}
::ng-deep .datetime-panel .mat-calendar-body-selected {
  background-color: #52aaff;
  color: #fff;
}
::ng-deep .datetime-panel .mat-calendar-body-today:not(.mat-calendar-body-selected) {
  border-color: #52aaff;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
